import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';

import {Payment} from '../../../graphql/payments.datatypes';
import {gqlPayment} from '../../Payments/getPayment.api';

interface UnbalancedPaymentsData {
    getUnbalancedPayments: Payment[]
}

export const GET_UNBALANCED_PAYMENTS_QUERY = gql`
  query getUnbalancedPayments{
    getUnbalancedPayments {
        ${gqlPayment}
    }
  }
`;

export const getUnbalancedPayments = () => useQuery<UnbalancedPaymentsData>(
    GET_UNBALANCED_PAYMENTS_QUERY,
    {
        variables: {},
        
    }
);

export default getUnbalancedPayments;